<template>
  <div class="hello">
    <br />
    <section ref="print">
      <!--startprint-->
      <div id="PrintArea" class="printOrder-data">
        <div class="recipeBG">
          <!--
        <img src="../../../static/images/Recipe-XianCi.png" class="recipeBG" />
          -->
          <img :src="imgSource" class="recipeBG" />

          <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <p class="typeItemName">{{ form.name }}</p>
            <p class="typeItemGender">{{ form.gender }}</p>
            <p class="typeItemAge">{{ form.age }}</p>
            <p class="typeItemDateY">{{ form.dateY }}</p>
            <p class="typeItemDateM">{{ form.dateM }}</p>
            <p class="typeItemDateD">{{ form.dateD }}</p>
            <p class="typeItemSickDetail">{{ form.sickDetail }}</p>
            <div v-if="form.drugDetail.length<5">
            <div class="typeItemDrugDetail">
              <div v-for="item in form.drugDetail " :key="item">
                <p style="font-size:14px">{{item.drug_name}}</p>
                <p style="font-size:13px;position:relative; top:-8px">{{item.drug_useway}}</p>
              </div>
            </div>
            </div>
            <div v-else>
            <div class="typeItemDrugDetail">
              <div v-for="(item,i) in form.drugDetail " :key="item" style="position:relative">
                <p v-if="i<8" style="font-size:9px">{{item.drug_name}}</p>
                <p v-if="i<8" style="font-size:9px; position:relative; top:-8px " >{{item.drug_useway}}</p>
              </div>
            </div> 

                  
            <div class="typeItemDrugDetail2">
              <div v-for="(item,i) in form.drugDetail " :key="item" style="position:relative">
                <p v-if="i>=8" style="font-size:9px">{{item.drug_name}}</p>
                <p v-if="i>=8" style="font-size:9px; position:relative; top:-8px " >{{item.drug_useway}}</p>
              </div>
            </div> 

            </div>
            <img id="codeimg" class="qrimg" :src="getQRURL(form.recipeIDnum)" width="55" height="55"/>
            <img class="typeItemDrPic" :src="getDoctorSignPic(form.doctorID)" />
             <!--

            <img class="typeItemPhPic" :src="getDoctorSignPic(form.reviewerID)" />
            -->
            <p class="typeItemRecipeID">{{ form.recipeIDField }}</p>
          </el-form>
        </div>
      </div>
    </section>
    <!--endprint-->
    <el-form ref="form" :model="form" :rules="rules" label-width="200px" style="position:relative">
      <!--
      <el-form-item>
        <el-button type="primary" @click="doPrint('form')">打印处方</el-button>
      </el-form-item>
      -->
      <el-form-item>
        <el-button type="primary" @click="printSection()">打印处方</el-button>
      </el-form-item>
      <!--
      <el-button type="primary" @click="doPrint('form')">打印</el-button>
      -->
    </el-form>
  </div>
</template>

<script>
import qs from 'qs';
export default {
  name: "RecipePrint",

  data() {
    return {
      /*
      note: {
        backgroundImage:
          "url(" + require("../../../static/images/Recipe-XianCi.png") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "200px auto",
        marginTop: "5px"
      }, */
      imgSource: require("../../../static/images/Recipe-DiYiZhenSuo.png"),
      qrImageURL:"",
      RecipeRequestApi: "http://121.196.220.228:30002/requestMyRecipeDetail",
      qrApi:"http://121.196.220.228:30002/qrcode/txt?text=",
      qrURL:"http%253A%252F%252F121.196.220.228%252F%2523%252FQRLink%253Fid%253D",
      //qrURL:"http%253A%252F%252Flocalhost%253A8080%252F%2523%252FQRLink%253Fid%253D",
      //doctorSignPic :require("../../../static/images/Sign_2.png"),
      //phSignPic : require("../../../static/images/Sign_3.png"),
      form: {
        name: "",
        gender: "",
        age: "",
        dateY: "",
        dateM: "",
        dateD: "",
        sickDetail: "",
        drugDetail: [],
        recipeIDField: "",
        recipeIDnum: "",
        doctorID: "",
        reviewerID: "",
      },
      useWays: [
        { value: 1, label: "口服" },
        { value: 2, label: "外用" },
        { value: 3, label: "外敷" },
        { value: 4, label: "注射" },
        { value: 5, label: "其他" }
      ],

      DrugUnit: [
        { value: 1, label: "粒" },
        { value: 2, label: "片" },
        { value: 3, label: "袋" },
        { value: 4, label: "包" },
        { value: 5, label: "滴" },
        { value: 6, label: "毫升" },
        { value: 7, label: "克" },
        { value: 8, label: "毫克" },
        { value: 9, label: "颗" },
        { value: 10, label: "喷" },
        { value: 11, label: "揿" },
        { value: 12, label: "丸" },
        { value: 13, label: "贴" },
        { value: 14, label: "枚" },
        { value: 15, label: "支" },
        { value: 16, label: "IU" }
      ],

      rules: {}
    };
  },
  props: {
    msg: String
  },
  methods: {
    printSection() {
      this.$print(this.$refs.print);
    },
    getDoctorSignPic(num) {
      return require("../../../static/images/Sign_" + num + ".png");
    },
    doPrint() {
      var newstr = document.getElementsByClassName("printOrder-data")[0]
        .innerHTML;
      //console.log(newstr);
      document.body.innerHTML = newstr;

      window.print();
      // 重新加载页面，以刷新数据
      window.location.reload();
    },

    onSubmit(formName) {
      alert("back page", formName);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    PrefixInteger(num, n) {
      return (Array(n).join(0) + num).slice(-n);
    },

    getQRURL(num){
      let qrURL= this.qrApi+this.qrURL+ num;
      //console.log("qrURL");
      //console.log(qrURL);
      return qrURL;
    }
  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }else{
    var _this = this;

    _this.form.recipeIDnum = sessionStorage.getItem("PrintRecipeID");
    _this.form.recipeIDField = _this.PrefixInteger(Number(_this.form.recipeIDnum), 8);
    let datas = {
      recipeID: _this.form.recipeIDnum,
      authToken: sessionStorage.getItem("authToken")
       };
       //console.log(datas);
    _this.axios
      .post(_this.RecipeRequestApi, qs.stringify(datas))
      .then(response => {
        let res = response.data;
        //console.log(res);
        if (res.data.result == "success") {
          //console.log(res.data);
          _this.form.name = res.data.userInfo.name;
          _this.form.gender = res.data.userInfo.sex == "1" ? "男" : "女";
          _this.form.age = res.data.userInfo.age;
          _this.form.dateY = res.data.userSickInfo.recipeTime.split(/[- : T]/)[0];
          _this.form.dateM = res.data.userSickInfo.recipeTime.split(
            /[- : T]/
          )[1];
          _this.form.dateD = res.data.userSickInfo.recipeTime.split(
            /[- : T]/
          )[2];
          _this.form.sickDetail = res.data.userSickInfo.sickDetail;
          _this.form.doctorID = res.data.userSickInfo.doctorID;
          _this.form.reviewerID = res.data.userSickInfo.reviewerID;
          let count = 1;
          res.data.drugInfo.forEach(eachDrug => {
            let useWaystr = "";
            let unitStr = "";
            _this.useWays.forEach(eachUseWay => {
              if (eachUseWay.value == eachDrug.useway) {
                useWaystr = eachUseWay.label;
              }
            });

            _this.DrugUnit.forEach(eachUnit => {
              if (eachUnit.value == eachDrug.unit) {
                unitStr = eachUnit.label;
              }
            });
            let thisdrugName;
            if(eachDrug.volumn==2){
              thisdrugName = count + "." + eachDrug.drug_name+"  " + eachDrug.specification + " " +eachDrug.quantity+"剂" ;
            }else{
              thisdrugName = count + "." + eachDrug.drug_name+"  " + eachDrug.specification + " *" +eachDrug.quantity ;
            }
            let thisdrugUseWay ="用法用量: "+ useWaystr + "   每日" + eachDrug.frequency +"次   每次" +eachDrug.numPerTime +unitStr;
            count++;
            _this.form.drugDetail.push({
              drug_name: thisdrugName,
              drug_useway: thisdrugUseWay
            });
          });
        } else {
          alert(res.data.err.code);
        }
      }).catch((e) => { alert(e+"，登录超时，请重新登录");});
  }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.recipeBG {
  width: 450px;
  height: 645px;
  position: relative;
}
.typeItemName {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 77px;
  top: 96px;
}

.typeItemGender {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 180px;
  top: 96px;
}

.typeItemAge {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 245px;
  top: 96px;
}

.typeItemDateY {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 40px;
  top: 120px;
}

.typeItemDateM {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 105px;
  top: 120px;
}

.typeItemDateD {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 180px;
  top: 120px;
}

.typeItemSickDetail {
  color: black;
  font-size: 13px;
  position: absolute;
  left: 115px;
  top: 145px;
}

.typeItemDrugDetail {
  color: black;
  font-size: 11px;
  position: absolute;
  left: 70px;
  top: 174px;
}

.typeItemDrugDetail2 {
  color: black;
  font-size: 11px;
  position: absolute;
  left: 240px;
  top: 174px;
}

.typeItemDrPic {
  position: absolute;
  left: 290px;
  top: 560px;
  height: 20px;
}

.qrimg2{
    position: absolute;
    left: 315px;
    top: 440px;
}

.qrimg{
    position: absolute;
    left: 30px;
    top: 40px;
}

.typeItemPhPic {
  position: absolute;
  left: 280px;
  top: 570px;
  height: 20px;
}

.typeItemRecipeID {
  color: red;
  font-size: 14px;
  font-family:Verdana, Geneva, Tahoma, sans-serif;
  font-weight: bold;
  position: absolute;
  left: 310px;
  top: 70px;
}

.noprint {
  display: none;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

